import { useState, useEffect, useRef } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";

export function useIsFullscreen() {
  const [isFullscreen, setIsFullscreen] = useState(
    !!document?.fullscreenElement
  );
  useEffect(() => {
    const handler = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handler);

    return () => {
      document.removeEventListener("fullscreenchange", handler);
    };
  }, []);

  return isFullscreen;
}

export function useFullscreenElement() {
  const [fullscreenElement, setFullscreenElement] = useState(
    document?.fullscreenElement
  );

  useEffect(() => {
    const handler = () => {
      setFullscreenElement(document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handler);

    return () => {
      document.removeEventListener("fullscreenchange", handler);
    };
  }, []);

  return fullscreenElement;
}

const useFullscreenStyles = makeStyles(
  createStyles((theme) => ({
    fullscreen: {
      position: "fixed !important",
      top: "0 !important",
      right: "0 !important",
      bottom: "0 !important",
      left: "0 !important",
      zIndex: `${theme.zIndex.drawer + 50} !important`,
    },
  }))
);

export function useFullscreen() {
  const classes = useFullscreenStyles();
  const classesRef = useRef<any>(classes);

  useEffect(() => {
    const handler = () => {
      if (!classesRef.current) return
      const className = classesRef.current.fullscreen;
      if (document.fullscreenElement) return;
      for (const element of document.getElementsByClassName(className)) {
        element.classList.remove(className);
      }
    };

    document.addEventListener("fullscreenchange", handler);
    return () => {
      document.removeEventListener("fullscreenchange", handler);
    };
  }, []);

  return (element) => {
    classesRef.current = classes;
    element.classList.add(classesRef.current.fullscreen);
    document.body.requestFullscreen();
  };
}
